import { IGeoJson2DGeographicCoordinates } from '~/client/graph'

export function translateCoordinates(
  coordinates: IGeoJson2DGeographicCoordinates[],
  latitudeOffset: number,
  longitudeOffset: number,
): IGeoJson2DGeographicCoordinates[] {
  return coordinates.map(c => ({
    latitude: c.latitude + latitudeOffset,
    longitude: c.longitude + longitudeOffset,
  }))
}

export function computeScreenAlignedBoundingBox(
  centerLng: number,
  centerLat: number,
  shapeFeatureCoordinates: number[][],
  bearing: number,
): number[][] {
  if (!shapeFeatureCoordinates.length) return []

  const cosLat = Math.cos((centerLat * Math.PI) / 180)
  const rad = (-bearing * Math.PI) / 180
  const cos = Math.cos(rad)
  const sin = Math.sin(rad)

  let minX = Infinity
  let maxX = -Infinity
  let minY = Infinity
  let maxY = -Infinity

  for (const coord of shapeFeatureCoordinates) {
    const dLng = (coord[0] - centerLng) * cosLat
    const dLat = coord[1] - centerLat
    const screenX = dLng * cos + dLat * sin
    const screenY = -dLng * sin + dLat * cos

    minX = Math.min(minX, screenX)
    maxX = Math.max(maxX, screenX)
    minY = Math.min(minY, screenY)
    maxY = Math.max(maxY, screenY)
  }

  const corners = [
    { x: minX, y: maxY },
    { x: maxX, y: maxY },
    { x: maxX, y: minY },
    { x: minX, y: minY },
    { x: minX, y: maxY },
  ]

  return corners.map(({ x, y }) => {
    const dLng = x * cos - y * sin
    const dLat = x * sin + y * cos
    return [centerLng + dLng / cosLat, centerLat + dLat]
  })
}
